import {Icon} from 'front-onceforall-core';
import PropTypes from 'prop-types';
import messageTypes from '../utils/messageTypes';

function MessageView(props) {
  return (
    <div className={`box flex-container space-between mt-4 ${props.type} ${props.type === messageTypes.ERROR && 'rejected'}`}>
      <div className="d-flex align-items-center">
        {props.icon &&
          <div className="flex-shrink-0 mr-4">
            <Icon
              icon={props.icon}
              size={22}
            />
          </div>
        }
        <div>
          <h3 className="mb-2">
            {props.title}
          </h3>
          {props.text}
        </div>
      </div>
      {props.children}
    </div>
  );
}

MessageView.propTypes = {
  type: PropTypes.oneOf(Object.values(messageTypes)),
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  icon: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default MessageView;
